// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"8b9378fa","239":"327a5cda","453":"599247d0","732":"6ffc45ea","745":"b0f8f60f","977":"d87c2fdf"}[chunkId] + ".chunk.js";
};